import React, { useState } from "react";
import { Card, Icon, List, Table, Tag } from "antd";
import { useClaimList } from "../../Hook/hookClaimList";
import FilterSectionCashlessClaim from "../../Components/FilterSectionCashlessClaim";
import { columnsClaim } from "../UploadPdf/column";
import AllDataUser from "../../Hook/hookData";
import { useReadAllNotificationsOnMount } from "../../Hook/hookNotifClaim";

const ClaimPendingList = () => {
  const { lang } = AllDataUser();
  useReadAllNotificationsOnMount();
  const {
    setSelectedClaim,
    onSearchClaim,
    handleSearchClaim,
    handlePageClaimChange,
    reloadClaimStatus,
    dataClaim,
    selectedClaim,
    searchDataClaim,
    dataClaimStatus,
  } = useClaimList(null, null, null, true);

  return (
    <div
      style={{
        width: "95%",
        margin: "auto",

        height: "80vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <h3 style={{ margin: 0, borderBottom: "1px solid #e8e8e8" }}>
        Claim Pending
      </h3>

      <FilterSectionCashlessClaim
        searchDataClaim={searchDataClaim}
        handleSearchClaim={handleSearchClaim}
        onSearchClaim={onSearchClaim}
        dataClaimStatus={dataClaimStatus}
        dataClaim={dataClaim}
        reloadClaimStatus={reloadClaimStatus}
      />

      <div>
        <Table
          rowKey={"RocNo"}
          scroll={{ y: 420, x: "max-content" }}
          // rowSelection={rowSelection}
          columns={columnsClaim(lang)}
          dataSource={
            (!dataClaim.error && dataClaim.data && dataClaim.data.data.data) ||
            []
          }
          bordered
          pagination={{
            current: searchDataClaim.page,
            pageSize: searchDataClaim.pageSize,
            total:
              (!dataClaim.error &&
                dataClaim.data &&
                dataClaim.data.data.page.TotalData) ||
              0,
            onChange: handlePageClaimChange,

            showSizeChanger: false,
          }}
          loading={dataClaim.isFetching}
          rowClassName="row-animate"
          locale={{
            emptyText: (
              <div
                style={{
                  padding: 20,
                  height: 420,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {dataClaim.isFetching ? (
                  <span>Loading...</span>
                ) : (
                  <>
                    <Icon
                      type="inbox"
                      style={{ fontSize: 24, color: "#999" }}
                    />
                    <div style={{ marginTop: 8 }}>No Data Available</div>
                  </>
                )}
              </div>
            ),
          }}
        />
      </div>
    </div>
  );
};

export default ClaimPendingList;
